import {
    AmendPendingOrderRequest,
    AmendPendingOrderResponse,
    google,
    IAmendPendingOrderRequest,
} from 'sfx-web-contract';
import { convertToProtobufExpiryType } from '../../helpers/protobuf';
import { DeepRequired } from '../../types';
import { IAmendOrderRequest, IAmendOrderResponse, IStreamData } from '../../interfaces';

export const encodeAmendOrderRequest = (request: IAmendOrderRequest): Uint8Array => {
    const gReq: DeepRequired<IAmendPendingOrderRequest> = {
        OrderId: request.orderId,
        Quantity: request.quantity,
        Price: request.triggerPrice,
        Expiry: convertToProtobufExpiryType(request.expiryType),
        ExpiryDate: google.protobuf.StringValue.create({ value: request.expiryDate }),
    };

    return AmendPendingOrderRequest.encode(AmendPendingOrderRequest.create(gReq)).finish();
};

export const decodeAmendOrderResponse = (response: IStreamData<Uint8Array>): IAmendOrderResponse => {
    const {
        Accepted: isAccepted,
        Reason: reason,
    } = AmendPendingOrderResponse.decode(response.payload);

    return { isAccepted, reason };
};
